import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed } from "@fdr/static-ui/Typography";

const handleTagColor = (pickNumber?: number) => {
  switch (pickNumber) {
    case 1:
      return buildColor("green", "L2");
    case 2:
      return buildColor("grey", "D3");
    case 3:
      return buildColor("orange", "D2");
    default:
      return buildColor("grey", "L3");
  }
};

export const RunnerTagsWrapper = styled.div<{
  hasTimeformInfo?: boolean;
}>`
  margin: ${({ hasTimeformInfo }) =>
    hasTimeformInfo ? "0 0 12px 54px" : "0 0 12px 42px"};
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const RunnerTag = styled.span<{
  pickNumber?: number;
}>`
  font-size: 12px;
  font-family: ${fontCondensed};
  font-weight: 400;
  text-transform: uppercase;
  line-height: 12px;
  letter-spacing: 1px;
  padding: 2px 4px;
  border-radius: 2px;
  background-color: ${({ pickNumber }) => handleTagColor(pickNumber)};
  color: ${({ pickNumber }) =>
    pickNumber ? buildColor("white") : buildColor("grey", "D4")};
`;
